import React from "react"
import { PageProps } from "gatsby"
import "../styles/app.scss"
import FeaturedPosts from "../components/featured-posts"
import Posts from "../components/posts"
import "../styles/gordita/style.css"
import Layout from "../components/Layout"
import { Newsletter } from "@wp/ui"
import "animate.css"

const IndexPage: React.FC<PageProps> = () => {
  return (
    <Layout
      id="home"
      leftSide={<FeaturedPosts />}
      rightSide={
        <>
          <Posts />
          <div id="newsletter">
            <p className="font-sm-bold">
              Would you like content like this delivered to your inbox?
            </p>
            <Newsletter
              mailchimpURL="https://gmail.us17.list-manage.com/subscribe?u=4ce70e65553c75b0ba1146272&id=6731f94b1c"
              id="newsletter"
            />
          </div>
        </>
      }
    ></Layout>
  )
}

export default IndexPage
